import React from 'react';
import PropTypes from 'prop-types';

const HomeIcon = ({
  'data-cy': dataCy,
  className,
  color = 'inherit',
  desc = 'Home Icon',
  id = 'homeIcon',
  title = 'Home Icon',
}) => {
  return (
    <svg
      className={className}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      style={{ fill: color, enableBackground: 'new 0 0 1000 1000' }}
      aria-label={desc}
      data-cy={dataCy}
    >
      <title>{title}</title>
      <desc>{desc}</desc>
      <g>
        <path
          fill="inherit"
          d="M498.5,263.11L141.82,559.89v296.78c0,21.78,19.06,40.84,40.84,40.84h217.82V655.18h198.76v242.32h217.82
          c21.78,0,40.84-19.06,40.84-40.84V559.89L498.5,263.11z"
        />
        <path
          fill="inherit"
          d="M991.31,489.1L857.9,377.46V124.25c0-10.89-8.17-19.06-21.78-19.06H719.04c-13.61,0-21.78,8.17-21.78,19.06
          v119.8L547.51,118.8c-27.23-21.78-68.07-21.78-95.3,0L8.4,489.1c-10.89,8.17-10.89,21.78-2.72,29.95l38.12,43.56
          c8.17,10.89,19.06,10.89,27.23,2.72L498.5,208.65l430.19,356.68c8.17,8.17,21.78,5.45,27.23-2.72l38.12-43.56
          C1002.2,508.15,1002.2,497.26,991.31,489.1z"
        />
      </g>
    </svg>
  );
};

export default HomeIcon;

HomeIcon.propTypes = {
  'data-cy': PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.string,
  desc: PropTypes.string,
  id: PropTypes.string,
  title: PropTypes.string,
};
